export function getAppIdFromUrl() {
    const path = window.location.pathname;
    const parts = path.split('/').filter(Boolean);
    return parts.length > 0 ? parts[0] : null;
}